angular
    .module('app')
    .component('gameBundlesList', {
        templateUrl: '/templates/pages/game-bundles/game-bundles-list/game-bundles-list.html',
        controller: 'GameBundlesListController',
        controllerAs: 'vm',
    });